<template>
  <div class="page-container">
    <div class="search-box">
      <el-input v-model="params.name" placeholder="搜索厂区名称" clearable style="width:240px" @keyup.enter.native="loadData" @clear="loadData" />
      <el-button type="primary" icon="el-icon-search" @click="loadData">查询</el-button>
      <el-button v-if="hasPermission('factory_add')" type="success" icon="el-icon-plus" @click="openAdd">添加厂区</el-button>
    </div>

    <div class="table-box">
      <el-table :data="tableData" border v-loading="loading" empty-text="暂无厂区" height="100%">
        <el-table-column prop="name" label="厂区名称" min-width="160" />
        <el-table-column label="经度" min-width="120">
          <template slot-scope="scope">{{ scope.row.longitude }}</template>
        </el-table-column>
        <el-table-column label="纬度" min-width="120">
          <template slot-scope="scope">{{ scope.row.latitude }}</template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" min-width="170" />
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-link v-if="hasPermission('factory_edit')" type="primary" @click="openEdit(scope.row)">编辑</el-link>
            <el-link v-if="hasPermission('factory_delete')" type="danger" @click="removeRow(scope.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="total > params.page_count">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="params.page"
          :page-size="params.page_count"
          :total="total"
          @current-change="loadData"
        />
      </div>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" direction="rtl" size="520px" @close="resetForm">
      <div class="form-wrap">
        <el-form label-width="90px">
          <el-form-item label="厂区名称">
            <el-input v-model="form.name" placeholder="请输入厂区名称" />
          </el-form-item>
          <el-form-item label="位置搜索">
            <div class="search-row">
              <el-input v-model="kw" placeholder="输入关键词搜索位置" @keyup.enter.native="doSearch" />
              <el-button @click="doSearch">搜索</el-button>
            </div>
            <div v-if="searchList.length" class="search-list">
              <div v-for="(s, i) in searchList" :key="i" class="search-item" @click="pickSearch(s)">
                <div class="si-title">{{ s.title }}</div>
                <div class="si-addr">{{ s.address }}</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="经度">
            <el-input v-model="form.longitude" placeholder="点击地图或手动填写" />
          </el-form-item>
          <el-form-item label="纬度">
            <el-input v-model="form.latitude" placeholder="点击地图或手动填写" />
          </el-form-item>
          <el-form-item label="地图选点">
            <TMapPicker mode="point" :center="mapCenter" :value="pointValue" @change="onPick" />
          </el-form-item>
        </el-form>
        <div class="drawer-foot">
          <el-button @click="drawer = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import TMapPicker from '@/views/components/TMapPicker.vue'
import {
  getFactories, createFactory, updateFactory, deleteFactory, searchLocation
} from '@/api/sentinel'

export default {
  name: 'FactoryIndex',
  components: { TMapPicker },
  data() {
    return {
      params: { page: 1, page_count: 10, name: '' },
      tableData: [],
      total: 0,
      loading: false,
      drawer: false,
      drawerTitle: '添加厂区',
      saving: false,
      form: { id: 0, name: '', latitude: '', longitude: '' },
      kw: '',
      searchList: [],
      mapCenter: { lat: 30.2741, lng: 120.1551 }
    }
  },
  computed: {
    pointValue() {
      if (this.form.latitude && this.form.longitude) {
        return { lat: +this.form.latitude, lng: +this.form.longitude }
      }
      return null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    hasPermission(k) {
      return this.$store.getters.hasPermission(k)
    },
    loadData() {
      this.loading = true
      getFactories().then(res => {
        if (res.code === 200) {
          const list = (res.data && res.data.list) || []
          this.tableData = list
          this.total = list.length
        }
      }).finally(() => { this.loading = false })
    },
    openAdd() {
      this.drawerTitle = '添加厂区'
      this.form = { id: 0, name: '', latitude: '', longitude: '' }
      this.searchList = []
      this.drawer = true
    },
    openEdit(row) {
      this.drawerTitle = '编辑厂区'
      this.form = {
        id: row.id,
        name: row.name,
        latitude: row.latitude,
        longitude: row.longitude
      }
      this.mapCenter = { lat: +row.latitude, lng: +row.longitude }
      this.searchList = []
      this.drawer = true
    },
    doSearch() {
      if (!this.kw) return
      searchLocation(this.kw).then(res => {
        if (res.code === 200) {
          this.searchList = (res.data && res.data.list) || []
        }
      })
    },
    pickSearch(s) {
      this.form.name = s.title
      // 后端返回 latitude/longitude（mock 用 lat/lng），两者兼容
      const lat = s.latitude != null ? s.latitude : s.lat
      const lng = s.longitude != null ? s.longitude : s.lng
      this.form.latitude = lat
      this.form.longitude = lng
      this.mapCenter = { lat: +lat, lng: +lng }
      this.searchList = []
    },
    onPick(val) {
      this.form.latitude = val.lat
      this.form.longitude = val.lng
    },
    resetForm() {
      this.form = { id: 0, name: '', latitude: '', longitude: '' }
      this.kw = ''
      this.searchList = []
    },
    save() {
      if (!this.form.name) return this.$message.warning('请输入厂区名称')
      if (!this.form.latitude || !this.form.longitude) return this.$message.warning('请在地图上选择或填写经纬度')
      const payload = {
        name: this.form.name,
        latitude: +this.form.latitude,
        longitude: +this.form.longitude
      }
      this.saving = true
      const req = this.form.id ? updateFactory(this.form.id, payload) : createFactory(payload)
      req.then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.drawer = false
          this.loadData()
        }
      }).finally(() => { this.saving = false })
    },
    removeRow(row) {
      this.$confirm(`确认删除厂区「${row.name}」？`, '提示', { type: 'warning' }).then(() => {
        deleteFactory(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success('已删除')
            this.loadData()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.search-box {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.table-box { background: #fff; padding: 16px; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); }
.pagination { margin-top: 16px; text-align: right; }
.form-wrap { padding: 8px 16px; }
.search-row { display: flex; gap: 8px; }
.search-list { margin-top: 10px; border: 1px solid #ebeef5; border-radius: 4px; max-height: 200px; overflow-y: auto; }
.search-item { padding: 8px 12px; cursor: pointer; border-bottom: 1px solid #f2f3f5; }
.search-item:hover { background: #f5f7fa; }
.si-title { font-size: 14px; color: #1D2129; }
.si-addr { font-size: 12px; color: #86909c; margin-top: 2px; }
.drawer-foot { display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px; }
</style>
